import { render, staticRenderFns } from "./CommentsComponent.vue?vue&type=template&id=0ccee53d&scoped=true&"
import script from "./CommentsComponent.vue?vue&type=script&lang=js&"
export * from "./CommentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentsComponent.vue?vue&type=style&index=0&id=0ccee53d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccee53d",
  null
  
)

export default component.exports